export enum ExplosiveType {
  FIREWORKS = 'FIREWORKS',
  DANGEROUS_POWDERS = 'DANGEROUS_POWDERS',
  BOMB_MATERIAL = 'BOMB_MATERIAL',
  CHEMICAL_COMPOUNDS = 'CHEMICAL_COMPOUNDS',
}

export const ExplosiveTypesList = {
  [ExplosiveType.FIREWORKS]: 'Fireworks',
  [ExplosiveType.DANGEROUS_POWDERS]: 'Dangerous Powders',
  [ExplosiveType.BOMB_MATERIAL]: 'Bomb Material',
  [ExplosiveType.CHEMICAL_COMPOUNDS]: 'Chemical Compounds',
} as const;

export interface IExplosive {
  type?: ExplosiveType | null;
  quantity?: number | null;
}
